import React from 'react';
import classNames from 'classnames';
import { SML_SIZE } from '../constants/common';
var InputHelpText = function (_a) {
    var text = _a.text, _b = _a.helpTextType, helpTextType = _b === void 0 ? 'message' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.size, size = _d === void 0 ? SML_SIZE.S : _d, ctaText = _a.ctaText, onClick = _a.onClick;
    return (React.createElement("div", { className: "lfc-flex lfc-justify-between ".concat(className) },
        React.createElement("span", { className: classNames('lfc-font-medium lfc-m-0 lfc-mt-[4px]', {
                'lfc-text-xs': size === SML_SIZE.S,
                'lfc-text-sm': size === SML_SIZE.M,
                'lfc-text-red-500': helpTextType === 'error',
                'lfc-text-yellow-400': helpTextType === 'warning',
                'lfc-text-gray-300': helpTextType === 'message'
            }) }, text),
        !!ctaText && !!onClick && (React.createElement("span", { className: classNames("lfc-font-medium lfc-m-0 lfc-mt-[4px] ".concat(className, " lfc-underline lfc-text-blue-500 lfc-cursor-pointer"), {
                'lfc-text-xs': size === SML_SIZE.S,
                'lfc-text-sm': size === SML_SIZE.M
            }), onClick: onClick }, ctaText))));
};
export default InputHelpText;
//# sourceMappingURL=InputHelpText.js.map